import { Pipe, PipeTransform } from '@angular/core';
import { DatesUtil } from '@liberty-financial/ng-core';

@Pipe({
  name: 'toDate'
})
export class ToDatePipe implements PipeTransform {
  transform(value?: string | null): Date | undefined {
    if (!value || !DatesUtil.isValid(value)) {
      return;
    }

    return DatesUtil.convertToDate(value) ?? undefined;
  }
}
